class CartGiftBox {
  constructor() {
    this.initEvents();
    this.synchronousGifts();
    // 状态控制
    this.isHandlingCart = false;
    this.eventsBound = false;
    setTimeout(() => {
      this.init();
    }, 0);
  }

  init() {
    if (this.eventsBound) return;
    this.eventsBound = true;
    let self = this;

    document.addEventListener('click', function(event) {
      const popupTrigger = event.target.closest('.cart-gift-tips-container, .cart-gift-thumbnails-container');
      if (popupTrigger) {
        const popup = document.querySelector('.cart-gift-popup-container');
        if (popup) {
          popup.classList.toggle('hide');
        }
        return;
      }

      const popupCloseTrigger = event.target.closest('.cart-gift-popup-title .svg-wrapper');
      if (popupCloseTrigger) {
        const popup = popupCloseTrigger.closest('.cart-gift-popup-container');
        if (popup) {
          popup.classList.add('hide');
        }
        return;
      }

      const addButton = event.target.closest('.gift-product-add-button');
      if (addButton) {
        if (addButton.classList.contains('disabled')) {
          event.preventDefault();
          return;
        }
        addButton.querySelector('.loading__spinner').classList.remove('hidden');
        document.querySelectorAll('.gift-product-add-button').forEach(btn => {
          btn.classList.add('disabled');
        });
        let variantId = addButton.getAttribute("data-variant-id") || "";
        const selectElement = addButton.previousElementSibling?.querySelector('select.variant-select');
        if (selectElement && selectElement.value && selectElement.value !== "") {
          variantId = selectElement.value;
        }
        self.addToCart(variantId, {_selected_gifts: "true"});
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items') ? document.getElementById('main-cart-items').dataset.id : '',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer') ? document.getElementById('main-cart-footer').dataset.id : '',
        selector: '.js-contents',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }

  refreshCartUI = async (parsedState) => {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const mainCartWrapper = document.querySelector('cart-items');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    if (mainCartWrapper) mainCartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      let elementToReplace = document.getElementById(section.id) && document.getElementById(section.id).querySelector(section.selector);
      elementToReplace = elementToReplace || document.getElementById(section.id);
      const sectionHtmlText = parsedState?.sections[section.section] || '';
      if (!sectionHtmlText) return;
      const sourceElement = new DOMParser().parseFromString(sectionHtmlText, 'text/html').querySelector(section.selector);

      if (elementToReplace && sourceElement) {
        elementToReplace.innerHTML = sourceElement.innerHTML;
      }
    });
    if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }
  };

  // 增强版添加方法
  addToCart = async (variantId, properties = {}) => {
    await fetch("/cart/add.js",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: properties,
          sections: this.getSectionsToRender().filter((section) => section.section != '').map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      }
    )
    .then((response) => response.json())
    .then((parsedState) => {
      this.refreshCartUI(parsedState);
    });
  };

  fetchCart = async () => {
    const response = await fetch("/cart.js");
    return response.json();
  };

  // 更可靠的事件监听
  initEvents = () => {
    // 标准化事件监听
    const safeHandler = debounce(() => this.synchronousGifts(), 1000);

    // 兼容多种主题事件
    const events = [
      "ajaxCart:afterAdd",
      "ajaxCart:afterUpdate",
      "ajaxCart:afterRemove",
      "cart:updated",
      "cart:change",
      "cart:requestComplete",
    ];

    events.forEach((event) => {
      document.addEventListener(event, safeHandler);
    });

    // 表单提交兜底
    document.addEventListener("submit", (e) => {
      if (e.target.action?.match(/\/cart\/(add|change|update)/)) {
        safeHandler();
      }
    });

    // 拦截fetch/XHR请求（兜底方案）
    this.interceptCartRequests();
  };

  // 新增：请求拦截器
  interceptCartRequests = () => {
    const originalFetch = window.fetch;
    window.fetch = async (input, init) => {
      const res = await originalFetch(input, init);
      if (typeof input === "string" && input.includes("/cart/change")) {
        setTimeout(async () => {
          await this.synchronousGifts();
          this.init();
        }, 10);
      }
      return res;
    };
  };

  async clearCart(cart) {
    if (!cart?.items || !cart?.items.length) return;

    const updates = {};
    cart.items.forEach(item => {
      updates[item.key] = 0;
    });

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates,
        sections: this.getSectionsToRender().filter((section) => section.section != '').map((section) => section.section),
        sections_url: window.location.pathname
      }),
    })
    .then((response) => response.json())
    .then((parsedState) => {
      this.refreshCartUI(parsedState);
    });
  }

  synchronousGifts = async () => {
    if (this.isHandlingCart) {
      return;
    }
    this.isHandlingCart = true;
    try {
      let cart = await this.fetchCart();
      if (!cart) {
        return;
      }

      const hasMainItems = cart.items.some(item => !window.excludedVariantIds.includes(String(item.variant_id)));
      const packageVariantId = window.freePackageSettings?.variantId || '';
      const packagingItem = cart.items.find(item => String(item.variant_id) === packageVariantId);
      if (!hasMainItems) {
        await this.clearCart(cart);
      } else if (!packagingItem && packageVariantId) {
        await this.addToCart(packageVariantId, {_auto_gift: 'true'});
      }
    } catch (error) {
      console.error("Cart Gift error", error);
    } finally {
      this.isHandlingCart = false;
    }
  };
}

document.addEventListener('DOMContentLoaded', () => {
  new CartGiftBox();
});